var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      "default-active-key": "1"
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("基本信息")
    }
  }, [_c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.baseInfo, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), item.key === "rate" ? _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.dataFrom[item.key] === "day" ? _vm.$t("日费率") : _vm.dataFrom[item.key] === "shortTerm" ? _vm.$t("短期费率") : "-") + " ")]) : _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm.$t(_vm.dataFrom[item.key]) || "-"))])]);
  }), 0)]), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("保单信息"),
      "force-render": ""
    }
  }, [_c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.policyInfoList, function (item, index) {
    return _c("div", {
      key: index
    }, [item.key == "cancelMessage" && _vm.dataFrom2[item.key] || item.key != "cancelMessage" ? _c("div", {
      staticClass: "left"
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]) : _vm._e(), item.key == "cancelMessage" && _vm.dataFrom2[item.key] || item.key != "cancelMessage" ? _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.dataFrom2[item.key]) || "-") + " "), item.key == "policyNo" && _vm.dataFrom2.policyUrl && _vm.dataFrom2.policyUrl.length != 0 ? _c("a-button", {
      attrs: {
        type: "link"
      },
      on: {
        click: _vm.previewFun
      }
    }, [_vm._v(_vm._s(_vm.$t("保单预览")))]) : _vm._e()], 1) : _vm._e()]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险信息")))])]), _c("a-table", {
    staticClass: "marginT20",
    staticStyle: {
      width: "80%",
      margin: "0 auto"
    },
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.dataFrom2.insuranceList,
      align: "center",
      pagination: false,
      rowKey: "planCode"
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1), _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("干系人信息")
    }
  }, _vm._l(_vm.data, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("top-title", [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), item.download ? _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-button", {
      on: {
        click: function ($event) {
          return _vm.downloadImgFun(item.downloadName);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("下载照片")))])], 1) : _vm._e()]), _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2,
        staticClass: "infoBox"
      }, _vm._l(item2, function (item3, index3) {
        return _c("div", {
          key: index3,
          style: _vm.isImg(item3.value) ? "height:120px" : ""
        }, [_c("div", {
          staticClass: "left"
        }, [_vm._v(_vm._s(_vm.$t(item3.name)))]), _vm.isImg(item3.value) ? _c("div", {
          staticClass: "right right-img"
        }, [_c("img", {
          attrs: {
            src: item3.value,
            title: _vm.$t("点击查看大图"),
            alt: "查看大图"
          },
          on: {
            click: function ($event) {
              return _vm.imgView(item3.value);
            }
          }
        })]) : item3.name == "被保人姓名" && item3.isCancel ? _c("div", {
          staticClass: "right",
          staticStyle: {
            position: "relative"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.value) || "-") + " "), _c("img", {
          staticStyle: {
            position: "absolute",
            right: "20px",
            top: "10px",
            width: "50px",
            opacity: "0.5"
          },
          attrs: {
            src: require("../../../assets/shuiyin.png"),
            alt: ""
          }
        })]) : _c("div", {
          staticClass: "right"
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.value) || "-") + " ")])]);
      }), 0);
    })], 2);
  }), 0), _c("a-tab-pane", {
    key: "4",
    attrs: {
      tab: _vm.$t("退保信息")
    }
  }, [_vm.cancelInsuredInfo ? _vm._l(_vm.cancelInsuredInfo, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("top-title", [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), item.download ? _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-button", {
      on: {
        click: function ($event) {
          return _vm.downloadImgFun(item.downloadName);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("下载照片")))])], 1) : _vm._e()]), _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2,
        staticClass: "infoBox"
      }, _vm._l(item2, function (item3, index3) {
        return _c("div", {
          key: index3,
          style: _vm.isImg(item3.value) ? "height:120px" : ""
        }, [_c("div", {
          staticClass: "left"
        }, [_vm._v(_vm._s(_vm.$t(item3.name)))]), _vm.isImg(item3.value) ? _c("div", {
          staticClass: "right right-img"
        }, [_c("img", {
          attrs: {
            src: item3.value,
            title: _vm.$t("点击查看大图"),
            alt: "查看大图"
          },
          on: {
            click: function ($event) {
              return _vm.imgView(item3.value);
            }
          }
        })]) : _vm.isImgArr(item3.value) ? _c("div", {
          staticClass: "right right-img-arr"
        }, _vm._l(item3.value, function (item4, index4) {
          return _c("div", {
            key: index4
          }, [_c("img", {
            attrs: {
              src: item4,
              title: _vm.$t("点击查看大图"),
              alt: "查看大图"
            },
            on: {
              click: function ($event) {
                return _vm.imgView(item4);
              }
            }
          })]);
        }), 0) : item3.name == "被保人姓名" && item3.isCancel ? _c("div", {
          staticClass: "right",
          staticStyle: {
            position: "relative"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.value) || "-") + " "), _c("img", {
          staticStyle: {
            position: "absolute",
            right: "20px",
            top: "10px",
            width: "50px",
            opacity: "0.5"
          },
          attrs: {
            src: require("../../../assets/shuiyin.png"),
            alt: ""
          }
        })]) : _c("div", {
          staticClass: "right"
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.value) || "-") + " ")])]);
      }), 0);
    })], 2);
  }) : [_c("a-empty")]], 2)], 1), _c("preview-list-modal", {
    ref: "previewListRef",
    attrs: {
      previewVisible: _vm.previewVisible,
      fileList: _vm.fileList,
      download: true
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }), _c("a-modal", {
    staticClass: "policy-preview-class",
    attrs: {
      visible: _vm.previewImgVisible,
      footer: null,
      width: 500
    },
    on: {
      cancel: function ($event) {
        _vm.previewImgVisible = false;
      }
    }
  }, [_c("img", {
    attrs: {
      src: _vm.previewImg,
      title: _vm.$t("点击查看大图"),
      alt: "查看大图"
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };